"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleFE_PermissionsGroup_ = exports.ModuleFE_PermissionsGroup = exports.ModuleFE_PermissionsGroup_Class = void 0;
/*
 * Permissions management system, define access level for each of
 * your server apis, and restrict users by giving them access levels
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_1 = require("../../../index");
const frontend_1 = require("@nu-art/thunderstorm/frontend");
const dispatch_OnPermissionsGroupsUpdated = new frontend_1.ThunderDispatcher('__onPermissionsGroupsUpdated');
class ModuleFE_PermissionsGroup_Class extends frontend_1.ModuleFE_BaseApi {
    constructor() {
        super(index_1.DBDef_PermissionGroup, dispatch_OnPermissionsGroupsUpdated);
    }
}
exports.ModuleFE_PermissionsGroup_Class = ModuleFE_PermissionsGroup_Class;
exports.ModuleFE_PermissionsGroup = new ModuleFE_PermissionsGroup_Class();
exports.ModuleFE_PermissionsGroup_ = exports.ModuleFE_PermissionsGroup;
